import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setColumns } from '../store/actions/session';
import { peopleInformationMappings } from './people_constants';
import ColumnSelector from 'components/table_header/column_selector';

export class PeopleColumnSelector extends React.Component {
  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    onCancelColumns: PropTypes.func.isRequired,
    onSetColumns: PropTypes.func.isRequired
  };

  render() {
    return (
      <ColumnSelector
        {...this.props}
        defaultColumns={[]}
        informationMappings={peopleInformationMappings}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: state.session.currentColumns
});

const mapDispatchToProps = {
  onSetColumns: setColumns
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleColumnSelector);